import config from '../config.json'

export default {
  // 字典
  getDicts: '/dictinfo/querydictinfobycode',
  // 上传
  uploadUrl: config.api_url + '/upload/uploadfile',

  // 富文本编辑上传
  ueditor: config.api_url + '/ueditor/upload',

  // 菜单列表
  getUserMenuTree: config.api_url + '/user/getUserRoleMenuTree',
  // 验证是否有按钮权限
  getBtnAuth: config.api_url + '/user/checkButtonAuth',

  // 获取验证码
  getCode: {
    send: '/identifyingCode/sendCode'
  },
  // 登陆
  login: {
    // 常量-----本地session、token的名字
    sessionId: 'userSessionId',
    userInfo: 'ss_userName',
    // 登陆
    pcUserLogin: '/login/pcUserLogin',
    // 忘记密码
    forgetPwd: '/login/forgetPwd',
    // 个人中心修改姓名
    updateRealName: '/user/updateRealName',
    // 修改密码
    updatePassword: '/user/updatePassword',
    // 退出登陆
    logout: '/login/logout',
    //发送登录验证码
    sendCode: '/login/sendLoginCode'
  },

  /* 系统管理 */
  systemManage: {
    // 菜单管理
    menuManage: {
      queryMenuTreeWithButton: '/menu/queryMenuTreeWithButton',
      queryMenuTree: '/menu/queryMenuTree',
      updateMenu: '/menu/updateMenu',
      deleteMenu: '/menu/deleteMenu',
      addMenu: '/menu/createMenu'
    },
    buttonManage: {
      getButtonByMenuId: '/button/findButtonByMenuId',
      addButton: '/button/addButton',
      getButtonById: '/button/getMenuButtonById',
      deleteButton: '/button/deleteButton',
      updateButton: '/button/updateButton'
    },
    // 角色管理
    roleManage: {
      getRoles: '/role/getRoles',
      addRole: '/role/addRole',
      delRole: '/role/delRole',
      getRoleById: '/role/getRoleById',
      updateRole: '/role/updateRole',
      getAllRole: '/role/getAllRole'
    },
    // //配置项管理
    configManager: {
      queryConfigInfoByPage: '/configinfo/queryConfigInfo',
      getConfigInfoById: '/configinfo/queryOneConfigInfo',
      updateConfigInfo: '/configinfo/updateConfigInfo',
      createConfigInfo: '/configinfo/addConfigInfo'
    },
    // 作业调度管理
    jobmanager: {
      queryJob: '/job/queryJob',
      updateJob: '/job/updateJob',
      createJob: '/job/insertJob',
      deleteJob: '/job/deleteJob',
      pauseJob: '/job/pauseJob',
      restartJob: '/job/restartJob',
      runJob: '/job/runJob',
      resumeJob: '/job/resumeJob'
    },
    // 缓存管理
    cacheManager: {
      refreshDictCache: '/dictinfo/refreshDictCache',
      refreshConfigCache: '/configinfo/refreshConfigCache',
	  refreshAuthDataList: '/configinfo/refreshAuthDataList'
    },
    // 数据字典
    dataDictionary: {
      queryDicts: '/dictinfo/queryDicts',
      queryTransactionSource: '/dictinfo/queryTransactionSource',
      deleteTransactionSource: '/dictinfo/deleteTransactionSource',
      insertTransactionSource: '/dictinfo/insertTransactionSource',
      getTransactionSourceById: '/dictinfo/getTransactionSourceById',
      updatedictinfo: '/dictinfo/updatedictinfo',
      transactionSourceExport: config.api_url + '/dictinfo/transactionSourceExport'
    }
  },
  //请假管理
  itemsLeaveManage:{
    //获取已经审批通过的请假列表
    getItemsLeaveList: '/itemLeave/getItemsLeaveList',
    //导出请假列表
    leaveInfoExportExcel: config.api_url + '/itemLeave/leaveInfoExportExcel',
    saveItemLeave: '/itemLeave/saveItemLeave',
  },

  // 申请管理
  itemsManage: {
    // 获取我的待办或已办列表(oprType区分)
    getItemsHandleHistoryList: '/items/getItemsHandleHistoryList',
    // 我的待办或已办详情
    getItemsHandleHistoryById: '/items/getItemsHandleHistoryById',
    //排班任务列表
    getItemsHandleHistoryListById: '/items/getItemsHandleHistoryListById',
    //审批排班任务
    applyItemsTaskByIds: '/items/applyItemsTaskByIds',
    //根据申请id获取我的待办或已办详情
    getItemsHandleByItemId: '/items/getItemsHandleByItemId',
    // 获取派遣人员列表
    getUserListByCurrentUserId: '/items/getUserListByCurrentUserId',
    // 审批申请
    applyItemsById: '/items/applyItemsById',
    // 我的申请列表
    getItemsList: '/items/getItemsList',
    // 我的申请详情
    getItemsById: '/items/getItemsById',
    //入职申请详情
    getApplyUserInfo: '/items/getApplyUserInfo',
    // 操作我的的申请（撤回、删除、提交）
    operationItemsById: '/items/operationItemsById',

    // 添加请假申请
    insertItemLeave: '/items/insertItemLeave',
    // 保存请假申请
    saveItemLeave: '/items/saveItemLeave',
    //保存外勤申请
    saveItemOutWork: '/items/saveItemOutWork',
    // 添加调岗申请
    insertItemChpost: '/items/insertItemChpost',
    // 保存岗位申请
    saveItemChpost: '/items/saveItemChpost',
    // 添加临时任务申请
    insertItemTempTask: '/items/insertItemTempTask',
    // 保存临时任务申请
    saveItemTempTask: '/items/saveItemTempTask',
    // 修改临时任务申请
    editItemTempTask: '/items/editItemTempTask',
    // 添加入职申请
    insertItemSysUser: '/items/insertItemSysUser',
    //修改员工入职申请
    updateUserInfo: '/items/updateUserInfo',

    // 根据守护点id获取岗位列表
    getPostListByStationId: '/items/getPostListByStationId',
    // 根据岗位id获取班次列表
    getScheduleListByPostId: '/items/getScheduleListByPostId',
    // 获取其他大队长列表
    getOtherTeamsList: '/items/getOtherTeamsList',

    //获取临时任务列表
    getItemsTempTaskList: '/items/getItemsTempTaskList',

  },
  // 守护点
  station: {
    //获取当前用户的守护点列表
    getStationListByUser: '/station/getStationListByUser',
    //根据当前用户获取所有临时守护点列表
    getAllTempStationListByUser: '/station/getAllTempStationListByUser',
    //根据组织id获取守护点列表
    getStationListByOrg: '/station/getStationListByOrg',
    //获取所有守护点列表
	  getAllStationList: '/station/getAllStationList',
    //入职申请专用获取所负责的守护点列表
    getAllStationListForUser: '/station/getAllStationListForUser',
	//获取配置的守护点（考勤汇总统计）
	getConfigStation:config.api_url + '/station/getConfigStation',
	  getStationList: config.api_url + '/station/getStationList',
	  createStation: config.api_url + '/station/createStation',
	  getById: config.api_url + '/station/getById',
	  getPrincipal: config.api_url + '/station/getPrincipal',
	  createPost: config.api_url + '/station/createPost',
	  getPostByStation: config.api_url + '/station/getPostByStation',
	  createSubStation: config.api_url + '/station/createSubStation',
	  getPostScheduleByPostId:config.api_url + '/station/getPostScheduleByPostId',
	  createPostSchedule:config.api_url + '/station/createPostSchedule',
	  getStationPostRef:config.api_url + '/station/getStationPostRef',
	  getPostById:config.api_url + '/station/getPostById',
	  getOrgUsers:config.api_url + '/station/getOrgUsers',
	  getPostAllowance:config.api_url + '/station/getPostAllowance',
	  deleteOneAllowance:config.api_url + '/station/deleteOneAllowance',
	  deletePost:config.api_url + '/station/deletePost',
	  deleteStation:config.api_url + '/station/deleteStation',
	  getHistory:config.api_url + '/station/getHistory',
	  deletePostRef:config.api_url + '/station/deletePostRef',
	  deleteSchedule:config.api_url + '/station/deleteSchedule',
  }, // 员工管理
  employeeManagement: {
    // 组织架构管理
    organizationManage: {
      getAllDepartmentTree: '/organization/getOrganizationTree',
      //只获取保安管理部树
      getBADeptTree: '/organization/getBADeptTree',
      // 根据部门ID查看用户信息
      getPersonnelByDepartmentId: '/user/getUserByOrgIdAndUserName',
      // 新增组织
      insertOrganization: '/organization/insertOrganization',
      // 修改组织
      updateOrganization: '/organization/updateOrganization',
      // 删除组织
      deleteOrganization: '/organization/deleteOrganization',
      // 根据父id查询部门
      getOrganizationByPid: '/organization/getOrganizationByPid',
      //根据id查询部门
      getOrgByPid: '/organization/getOrgById'
    },
    userManage: {
      getUserByOrgIdAndUserName: '/user/getUserByOrgIdAndUserName',
      //离职
      quitPosition: '/user/quitPosition',
      insertUserInfo: '/user/insertUserInfo',
      //导出U8用户信息
      exportUser: config.api_url + '/user/exportUser',
      getUserInfoById: '/user/getUserInfoById',
      // 修改用户
      updateUserInfo: '/user/updateUserInfo',
      //导入用户U8编码
      importUserU8Code: config.api_url +'/user/importUserU8Code',
      //导入用户初始信息
      insertUser : config.api_url +'/user/insertUser',
      //根据用户名或者u8搜索用户
      searchUserByNameOrU8: config.api_url +'/user/searchUserByNameOrU8',
      //员工调岗
      updateOrgUserByUserId:'/user/updateOrgUserByUserId',
      //用户详情
      getUserInfo : '/user/getUserInfo',
      //根据组织查询负责人
      getUserByOrgId:'/user/getUserByOrgId',
      //获取员工属性
      getExportUserAttribute : '/user/getExportUserAttribute',
      //导出员工信息
      exportUserInfo:config.api_url + '/user/exportUserInfo',
      //根据名称查询
      getUserNameList:'/user/getUserNameList',
      //根据组织id获取用户列表
      getOrgUsersByOrgId:'/user/getOrgUsersByOrgId'


    },
    contract: {
      //条件查询
      findContract: config.api_url +'/contract/findContractModels',
      //根据id查询
      getContractById: config.api_url +'/contract/getContractById',
      //根据id删除
      deleteById: config.api_url +'/contract/deleteById',
      //创建修改
      createOrUpdate: config.api_url +'/contract/createOrUpdate',
      batchImportContract: config.api_url +'/contract/batchImportContract',
    },
    msgDefine: {
      //条件查询
      findMsgDefines: config.api_url +'/msgDefine/findMsgDefines',
      //根据id查询
      getMsgDefineById: config.api_url +'/msgDefine/getMsgDefineById',
      //根据id删除
      deleteById: config.api_url +'/msgDefine/deleteById',
      //创建修改
      createOrUpdate: config.api_url +'/msgDefine/createOrUpdate',
      //发布
      publishMsgDefine: config.api_url +'/msgDefine/publishMsgDefine'

    },
    personChange:{
      //获取人事异动分析
      getAllPersonChangeInfo : '/personChange/getAllPersonChangeInfo',
      //导出人事异动
      exportAllPersonChangeInfo :config.api_url +'/personChange/exportAllPersonChangeInfo'
    }
  },
  //工资管理
  salarymanage : {
    otherinfo: {
      //导入
      importOtherInfo: config.api_url +'/otherinfo/importOtherInfo',
      //条件查询
      findOtherInfo: config.api_url +'/otherinfo/findOtherInfo',
      //根据id查询
      getOtherInfoById: config.api_url +'/otherinfo/getOtherInfoById',
      //根据id删除
      deleteById: config.api_url +'/otherinfo/deleteById',
      //创建修改
      createOrUpdate: config.api_url +'/otherinfo/createOrUpdate'
    },
    salary : {
       //工资结算
       settlement: config.api_url +'/salary/settlement' ,
       //工资结算导出
       settlementExport: config.api_url +'/salary/settlementExport',
       //通过月份和守护点获取工资合计
       getTotalPayByStationIdAndMouth:config.api_url +'/salary/getTotalPayByStationIdAndMouth',
    }
  },
  myMsgInfo:{
    //查询我的消息
    findMsgInfos: '/msgInfo/findMsgInfos',
    getMsgInfoById : '/msgInfo/getMsgInfoById',
    deleteByIds : '/msgInfo/deleteByIds',
  },
  //考勤管理
  attendance:{
    //考勤分析
    atndAnalysis:config.api_url +'/attendStatis/atndAnalysis',
    //考勤统计表
    atndStatis:config.api_url +'/attendStatis/atndStatis',
    //考勤统计表-导出
    atndStatisExport:config.api_url +'/attendStatis/atndStatisExport',
    //考勤分析-导出
    atndAnalysisExport:config.api_url +'/attendStatis/atndAnalysisExport',
    //实勤工时统计
    allRealWorkHours :config.api_url +'/attendStatis/allRealWorkHours',
    //根据用户和月份查询考勤
    personlAtndStatis:config.api_url +'/attendStatis/personlAtndStatis',
    //考勤汇总统计表
    getMonthAttend:config.api_url +'/attendStatis/getMonthAttend',
    //考勤汇总统计表导出
    monthAttendExport:config.api_url +'/attendStatis/monthAttendExport'
  },
  //国家节假日管理
  holidayManege:{
      deleteNationHoliday:config.api_url +'/nationHoliday/deleteNationHoliday',
      getNationHolidayById:config.api_url +'/nationHoliday/getNationHolidayById',
      getNationalHolidays:config.api_url +'/nationHoliday/getNationalHolidays',
      insertNationHoliday:config.api_url +'/nationHoliday/insertNationHoliday',
      updateNationHoliday:config.api_url +'/nationHoliday/updateNationHoliday'
  }
}



// WEBPACK FOOTER //
// ./src/common/api.js